import { EmissionsCategoryEnum } from '@shared/api/types';
import Text from '@shared/components/content/text';
import RatingCloud from '@shared/components/ratings/rating-cloud';
import { Card } from '@shared/components/ui/card';
import { formatSmallNumber } from '@shared/lib/utils';

export function HighestEmissionsItemsCard({
  item,
  rating,
  totalPurchased,
  totalEmissions,
  pctOfEmissions,
  downloadMode,
}: {
  item: string;
  rating: EmissionsCategoryEnum;
  totalPurchased: number;
  totalEmissions: number;
  pctOfEmissions: number;
  downloadMode: boolean;
}) {
  return (
    <Card className="grid grid-cols-11 items-center gap-4 border-teal-400 p-3">
      <Text
        includeHover
        className="col-span-3 !line-clamp-2 !text-ellipsis font-heading font-medium"
      >
        {item}
      </Text>
      <RatingCloud
        rating={rating}
        className="col-span-2 justify-self-center"
        format={downloadMode ? 'png' : 'svg'}
      />
      <Text className="col-span-2 text-right">
        {formatSmallNumber(totalPurchased)}
      </Text>
      <Text className="col-span-2 text-right">
        {formatSmallNumber(totalEmissions)}
      </Text>
      <Text className="col-span-2 text-right">
        {formatSmallNumber(pctOfEmissions)}%
      </Text>
    </Card>
  );
}
